import gql from 'graphql-tag';

export default gql`
  query {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        configurations {
          googleTagManagerId
        }
      }
    }
  }
`;
